import { useAuthStore } from '@/store/auth.store'

/**
 * Per-user localStorage key: `<baseKey>:<userId>` (same `:<userId>` suffix
 * as `columnPrefsKey`), so a shared office PC keeps each login's layout.
 * Read synchronously from the auth store — callers run in `useState`
 * initializers, before the first paint.
 */
export function userScopedKey(baseKey: string, userId?: string | null): string {
  const id = userId ?? useAuthStore.getState().session?.user?.id
  return `${baseKey}:${id || 'anon'}`
}

/**
 * Raw stored value for this user. Falls back once to the legacy unscoped key
 * (layouts saved before prefs were per user) so nobody loses their columns
 * on upgrade; the next write goes to the per-user key only.
 */
export function readUserScoped(baseKey: string): string | null {
  try {
    return localStorage.getItem(userScopedKey(baseKey)) ?? localStorage.getItem(baseKey)
  } catch {
    return null
  }
}

export function writeUserScoped(baseKey: string, value: string): void {
  try {
    localStorage.setItem(userScopedKey(baseKey), value)
  } catch {
    // Private mode / quota — falls back to defaults next load.
  }
}
